// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__RcsgS","content":"LoadingScreen_content__k4qs8","spinner":"LoadingScreen_spinner__x7Oy4","text":"LoadingScreen_text__NM721"};